<template>
	<div class="trun-user">
		<div class="page-handle">
			<div class="left">
				<a-button v-auth="'100101'" type="primary" @click="addUserModel">新建用户</a-button>
				<a-button v-auth="'100104'" v-if="btnIsVisible" @click="importClick" type="primary">导入用户</a-button>
				<a-button v-auth="'100105'" v-if="btnIsVisible" @click="exportUserInfo">导出全部</a-button>
			</div>
			<div class="right">
				<a-input-search placeholder="请输入姓名/手机号" style="width: 200px" @search="searchUser"/>
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchLableKey}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
					        @click="onClickSearchKey">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in searchMapKey" :key="item.status">
							<a href="javascript:;">{{item.text}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					:pagination="false"
					:columns="columns"
					:dataSource="data"
					:loading="loading"
					:rowKey="record => record.userId"
					class="hospital-table"
					size="middle"
			>
				<template slot="operateStatusDict" slot-scope="text,record,index">
					<span v-if="record.status == 1">正常</span>
					<span v-if="record.status == 0">禁用</span>
				</template>
				<template slot="optUser" slot-scope="text,record,index">
					<template v-if="record.roleId != 1">
						<a v-auth="'100102'" href="javascript:;" @click="editUserInfo(record)" class="cf-mr10">编辑</a>
						<a v-auth="'100102'" :class="{disableClass:isLoginUser(record.username)}"
						   v-if="record.status == 1" href="javascript:;"
						   @click="editUserStatus(record)" class="cf-mr10">禁用</a>
						<a v-auth="'100102'" :class="{disableClass:isLoginUser(record.username)}" v-else
						   href="javascript:;" @click="editUserStatus(record)" class="cf-mr10">启用</a>
						<a v-auth="'100106'" href="javascript:;" @click="resetUserPWDModel(record)">重置密码</a>
					</template>
					<template v-else>-</template>
				</template>
			</a-table>
		</div>
		<div class="pagination">
			<a-pagination
					@change="pageChange"
					:pageSize.sync="pageSize"
					v-model="page"
					size="small"
					:total="resData.total"
			/>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<user-add v-if="visible" @close="closeModel" :userInfo="userInfo"></user-add>
		</page-model>
		<page-model @close="closeModel" :visible="resetIsVisible">
			<div class="form-model-main reset-model">
				<div class="add-page-content">
					<div class="title">重置密码</div>
					<div class="content">确定要重置密码吗？</div>
					<div class="confrim-footer">
						<a-button type="primary" class="cf-mr10" :loading="isHttpSubmit" @click="submitReset">确定
						</a-button>
						<a-button @click="cancelSubmit">取消</a-button>
					</div>
				</div>
			</div>
		</page-model>
		<page-model @close="closeModel" :visible="statusIsVisible">
			<div class="form-model-main reset-model">
				<div class="add-page-content">
					<template v-if="userStatusInfo.status == 1">
						<div class="title">禁用操作</div>
						<div class="content">确定要禁用吗？</div>
					</template>
					<template v-if="userStatusInfo.status == 0">
						<div class="title">启用操作</div>
						<div class="content">确定要启用吗？</div>
					</template>
					<div class="confrim-footer">
						<a-button type="primary" class="cf-mr10" :loading="isHttpSubmit" @click="submitUpStatus">确定
						</a-button>
						<a-button @click="cancelSubmit">取消</a-button>
					</div>
				</div>
			</div>
		</page-model>
	</div>
</template>

<script>
  import UserAdd from "./userAdd.vue";
  import db from '@/common/localstorage';

  const columns = [
    {
      title: "人员编号",
      dataIndex: "userId",
      width: '10%'
    },
    {
      title: "用户名",
      dataIndex: "username",
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      width: '10%'
    },
    {
      title: "角色",
      dataIndex: "roleName",
      customRender: (text, record, index) => {
        if (!record.roleName) {
          return '-'
        } else {
          return record.roleName
        }
      }
    },
    {
      title: "组织",
      dataIndex: "deptName",
      customRender: (text, record, index) => {
        if (!record.deptName) {
          return '-'
        } else {
          return record.deptName
        }
      }
    },
    {
      title: "手机",
      dataIndex: "mobile",
      customRender: (text, record, index) => {
        if (!record.mobile) {
          return '-'
        } else {
          return record.mobile
        }
      }
    },
    {
      title: "邮箱",
      dataIndex: "email",
      customRender: (text, record, index) => {
        if (!record.email) {
          return '-'
        } else {
          return record.email
        }
      }
    },
    {
      title: "状态",
      // dataIndex: "status"
      scopedSlots: {customRender: "operateStatusDict"},
      width: '10%'
    },
    {
      title: "操作",
      scopedSlots: {customRender: "optUser"},
      width: '15%'
    }
  ];
  export default {
    data() {
      return {
        columns,
        visible: false,
        resetIsVisible: false,
        statusIsVisible: false,
        btnIsVisible: true,
        isHttpSubmit: false,
        loading: false,
        data: [],
        resData: [],
        page: 1,
        pageSize: 10,
        deptId: "",
        username: "",
        userInfo: {},
        resetUserId: "",
        userStatusInfo: {},
        searchKey: '',
        searchMapKey: [{status: '1', text: '正常'}, {status: '0', text: '禁用'}],
        searchLableKey: '状态',
        userData: db.get('userInfo'),
      };
    },
    components: {UserAdd},
    watch: {
      $route(val) {
        let queryDeptId = val.query.deptId ? val.query.deptId.split("-") : [];
        if (queryDeptId.length > 0) {
          this.deptId = queryDeptId[queryDeptId.length - 1];
          this.btnIsVisible = false;
        } else {
          this.deptId = '';
          this.btnIsVisible = true;
        }
        this.page = 1;
        this.getUserLst();
      }
    },
    mounted() {
      let queryDeptId = this.$route.query.deptId
        ? this.$route.query.deptId.split("-")
        : [];
      if (queryDeptId.length > 0) {
        this.deptId = queryDeptId[queryDeptId.length - 1];
        this.btnIsVisible = false;
      } else {
        this.btnIsVisible = true;
      }
      this.getUserLst();
    },
    methods: {
      onClickSearchKey({key}) {
        if (key == '-1') {
          this.searchKey = '';
          this.searchLableKey = '状态';
        } else {
          let textValue = '';
          this.searchKey = key;
          this.searchMapKey.forEach(function (item, i) {
            if (item.status == key) {
              textValue = item.text;
              return;
            }
          })
          this.searchLableKey = textValue;
        }
        this.getUserLst();
      },
      isLoginUser(userName) {
        return this.userData.username === userName;
      },
      addUserModel() {
        this.userInfo = {};
        this.visible = true;
      },
      editUserInfo(row) {
        this.visible = true;
        this.userInfo = row;
      },
      editUserStatus(row) {
        if (this.isLoginUser(row.username)) {
          return;
        }
        this.userStatusInfo = row;
        this.statusIsVisible = true;
      },
      resetUserPWDModel(row) {
        this.resetIsVisible = true;
        this.resetUserId = row.userId;
      },
      closeModel() {
        this.visible = false;
        this.resetIsVisible = false;
        this.statusIsVisible = false;
        this.getUserLst();
      },
      getUserLst() {
        this.loading = true;
        this.$get("user", {
          pageSize: this.pageSize,
          pageNum: this.page,
          mobileOrUserName: this.username,
          deptId: this.deptId,
          status: this.searchKey,
        }).then(
          res => {
            this.resData = res.data;
            this.data = this.resData.rows;
            this.loading = false;
          },
          err => {
            console.log("err", err);
            this.loading = false;
          }
        );
      },
      searchUser(value) {
        this.username = value;
        this.getUserLst();
      },
      pageChange(page, pagesize) {
        this.page = page;
        this.pageSize = pagesize;
        this.getUserLst();
      },
      importClick() {
        this.$router.push("/turn/import");
      },
      exportUserInfo() {
        let dFilename = this.$moment().format('YYYYMMDD') + "_用户管理";
        this.$export('user/excel', {}, dFilename);
      },
      cancelSubmit() {
        this.resetIsVisible = false;
        this.statusIsVisible = false;
      },
      submitUpStatus() {
        this.isHttpSubmit = true;
        this.$put("user/profile", {
          userId: this.userStatusInfo.userId,
          status: this.userStatusInfo.status == 1 ? 0 : 1
        }, {
          "Content-Type": "application/json"
        }).then(
          res => {
            if (this.userStatusInfo.status == 1) {
              this.$message.success("用户禁用成功！");
            } else {
              this.$message.success("用户启用成功！");
            }
            this.isHttpSubmit = false;
            this.closeModel()
          },
          error => {
            this.isHttpSubmit = false;
            if (this.userStatusInfo.status == 1) {
              this.$message.error("用户禁用失败！");
            } else {
              this.$message.error("用户启用失败！");
            }
          }
        );
      },
      submitReset() {
        this.isHttpSubmit = true;
        this.$put("user/password/reset?id=" + this.resetUserId, {}).then(
          res => {
            this.$message.success("重置密码成功");
            this.resetIsVisible = false;
            this.isHttpSubmit = false;
          },
          error => {
            this.isHttpSubmit = false;
            this.$message.error("重置密码失败!");
          }
        );
      }
    }
  };
</script>

<style lang="scss">
	.trun-user {
		.pagination {
			padding: 0px 40px;
		}
	}

	.reset-model {
		.add-page-content {
			width: 380px;
		}
		.add-page-content .content {
			border: 0;
			padding: 0 0 30px 0;
			font-size: 18px;
		}
	}

	a.disableClass {
		color: #999;
		cursor: auto;
	}
</style>